import React from 'react'

function TitleTool() {
  return (
    <div className='title-tool'>
        <div className='title-tool-text'>
            EXPENSE TOOL 
        </div>
      
    </div>
  )
}

export default TitleTool